import React, { forwardRef } from "react";
import { Paper, Box, Typography } from "@mui/material";

/**
 * Visual shell of a map info card: header (icon, title, subtitle, actions)
 * and a scrolling body. Positioning on the map lives in MapInfoCard.
 */
const InfoCardFrame = forwardRef(function InfoCardFrame(
  {
    title,
    subtitle,
    icon,
    width = 280,
    headerColor,
    headerActions = null,
    children,
    sx,
    ...paperProps
  },
  ref,
) {
  return (
    <Paper
      ref={ref}
      elevation={4}
      sx={{
        width,
        borderRadius: 1.25,
        border: "1px solid rgba(0,79,125,0.16)",
        overflow: "hidden",
        ...sx,
      }}
      {...paperProps}
    >
      <Box
        sx={{
          px: 1.25,
          py: 0.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: headerColor ? `${headerColor}1A` : "rgba(0,79,125,0.06)",
          borderBottom: headerColor ? `2px solid ${headerColor}` : "none",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
          {icon}
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ color: headerColor ?? "#004f7d", fontSize: 13, fontWeight: 700 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography noWrap sx={{ color: "#57728d", fontSize: 11 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {headerActions ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
            {headerActions}
          </Box>
        ) : null}
      </Box>

      <Box sx={{ maxHeight: 400, overflowY: "auto" }}>{children}</Box>
    </Paper>
  );
});

export default InfoCardFrame;
